/**
 * Created by Issmahane on 11/11/2016 ??. Edited by Amine 15/03/2021
 */
(function () {
    'use strict';

    const {HTMLS} = require('shared/utils/requires');
    const LIST_DIALOG = require('../dialogs/list-dialog');

    class MultiSelectController {
        constructor(listService, $mdDialog, $attrs) {
            this.dialog = $mdDialog;
            this.service = listService;

            this.model = $attrs['mnModel'];
            this.label = $attrs['mnLabel'];
            this.tpl = _.isString($attrs['mnTpl']) ? $attrs['mnTpl'] : "default";
            this.ngModelController = this.ngModelController ? this.ngModelController : null;

            this.internalValue = [];
        }

        static get $inject() {
            return ["listService", "$mdDialog", "$attrs"];
        }

        $onInit() {
            this.tplParams = _.isNil(this.tplParams) ? {} : this.tplParams;

            this.service.list(this.model)
                .then(data => {
                    this.initItems = data;
                    this.items = _.cloneDeep(this.initItems);
                });
            this.ngModelController.$render = () => this.renderCurrentValue();
        }

        internalValueChanged() {
            this.ngModelController.$setViewValue(_.cloneDeep(this.internalValue));
            this.ngModelController.$commitViewValue();
        }

        renderCurrentValue() {
            this.items = _.cloneDeep(this.initItems);

            if (this.ngModelController.$viewValue !== this.internalValue) {
                this.internalValue = this.ngModelController.$viewValue
                this.internalValueChanged();

                if (!_.isArray(this.internalValue)) {
                    this.internalValue = [];
                }

                if (this.internalValue.length > 0) {
                    this.items = _.cloneDeep(this.initItems);
                    this.internalValue.each(item => {
                        this.items = _.reject(this.items, ['id', item.id]);
                    });
                } else {
                    this.items = _.cloneDeep(this.initItems);
                }
            }
        }

        selectItem(item) {
            if (item.selected) {
                item.selected = false;
                this.internalValue = _.reject(this.internalValue, ['id', item.id]);
            } else {
                item.selected = true;
                this.internalValue.push(_.omit(item, "selected"));
            }

            this.internalValueChanged();
        }


        cancel() {
            this.internalValue = [];
            this.internalValueChanged();
        }


        add(ev) {
            const tplPath = HTMLS[`shared/views/list.${this.tpl}.tpl.html`];

            this.dialog.show(_.assign({}, LIST_DIALOG, {
                targetEvent: ev,
                locals: {
                    mnLabel: this.label,
                    mnModel: this.model,
                    tplParams: this.tplParams
                },
                template: tplPath,
            })).then(item => {
                this.items.push(item);
                this.selectItem(item)
            });
        }

    }

    tpl.$inject = ['$element', '$attrs'];

    function tpl(element, attrs) {
        element.addClass('layout-row');

        const isDisabled = $(element).is('[disabled]') ? "disabled" : "";
        const disabled = !_.isNil(attrs['mnDisabled']) ? 'ng-disabled="vm.disabled"' : "";

        return `<md-content class="flex">
                    <md-list>
                        <md-list-item ng-if="!vm.items || vm.items.length == 0" class="layout-row">
                            <div class="empty-content layout-row layout-align-start-center flex">
                                <md-icon md-font-icon="mdi-alert-circle-outline" md-font-set="mdi" aria-label="warning"></md-icon>
                                <span translate-once="no_element_to_show"></span>
                            </div>
                        </md-list-item>
                        <md-list-item ng-class="{selected: item.selected}" ng-repeat="item in vm.items track by item.id" 
                                ng-click="vm.selectItem(item)" aria-label="item" ${disabled} ${isDisabled}>
                            <p ng-bind="item.value"></p>
                            <md-icon md-font-icon="mdi-check" md-font-set="mdi" ng-show="item.selected"></md-icon>
                        </md-list-item>
                    </md-list>
               </md-content>
               <div class="mn-option-buttons mn-left-padding layout-column">
                    <md-button ng-if="!vm.mnDisabled" class="md-icon-button" ng-click="vm.add($event)" aria-label="add" tabindex="-1">
                        <md-icon md-font-icon="mdi-plus" md-font-set="mdi"></md-icon>
                    </md-button>
                    <md-button ng-if="!vm.mnDisabled" class="md-icon-button" ng-click="vm.cancel()" aria-label="cancel" tabindex="-1">
                        <md-icon md-font-icon="mdi-close" md-font-set= "mdi"></md-icon>
                    </md-button>
               </div>`;
    }

    module.exports = {
        controllerAs: "vm",
        controller: MultiSelectController,
        bindings: {
            //list: "=ngModel",
            change: "&ngChange",
            disabled: "=mnDisabled",
            tplParams: "<?tplParams"
        },
        require: {
            ngModelController: 'ngModel'
        },
        template: tpl, // or template
    };

})();
